
import axios from 'axios'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import XHeader from "vux/src/components/x-header/index";

export default {
name: 'EditPage',
components: {XHeader, Toast,XDialog},
data() {
return {
mobile: '',
name: '',
school: '',
education: '',
graduate: '',
major: '',
stuReason: '',
personalReason: true,
zf: false,

files2: [],

picture2: '',

formData2: {},
f: true,
specificReason:'',
listboxHeight: '1365'
}
},
mounted() {
this.mobile = sessionStorage.getItem('mobile')

this.FindMessage()

if (sessionStorage.getItem('mobile') === null) {
this.$router.push({path: '/FindDetail'})
}
this.timeSelect()
},
methods: {

getTimeState: function () {

let timeNow = new Date();

let hours = timeNow.getHours();

let state = '';
if (hours >= 0 && hours <= 10) {
state = '同学上午好！'
} else if (hours >10 && hours <= 14) {
state = '同学中午好！'
} else if (hours >14 && hours <= 18) {
state = '同学下午好！'
} else if (hours >18 && hours <= 24) {
state = '同学晚上好！'
}
return state
},

timeSelect: function () {
let date = new Date();
let nowYear = date.getFullYear();
let year_select = document.getElementById('graduate');
for (let i = nowYear; i > parseInt(nowYear) - 10; i--) {
let optionYear = document.createElement('option');
optionYear.innerHTML = i + '年';
optionYear.value = i + '年';
year_select.appendChild(optionYear)
}
},
ChangeType: function (ele) {


let select = this.stuReason
this.zf = true
if (select === '其他个人原因') {
this.personalReason = true

this.listboxHeight = 1375
} else {
this.personalReason = false
this.listboxHeight = 1110
}
},

FindMessage: function () {
this.mobile = this.$route.params.mobile

if (this.mobile == null) {
this.mobile = sessionStorage.getItem('mobile')
}
let param = new URLSearchParams()
param.append('mobile', this.mobile)
axios.post('http://student.hmifo.com/admin/application/findByKey', param).then((r) => {
console.log(r)
if (r.data.code === 200) {
if (r.data.data !== null) {
this.name = r.data.data.name
this.mobile = r.data.data.mobile
this.school = r.data.data.school
this.education = r.data.data.education
this.graduate = r.data.data.graduate

this.major = r.data.data.major

this.stuReason = r.data.data.stuReason

this.specificReason = r.data.data.specificReason == 'null' ? '': r.data.data.specificReason


this.ChangeType()

this.edit = true
if (r.data.data.pay != undefined) {
this.picture2 = r.data.data.pay
this.files2.push({url: 'http://student.hmifo.com/admin/application/storage/' + r.data.data.pay})
} else if (r.data.data.credit != undefined) {
this.picture2 = r.data.data.credit
this.files2.push({url: 'http://student.hmifo.com/admin/application/storage/' + r.data.data.credit})
}
this.edit2 = true
} else {
this.$vux.toast.text('数据查询失败!')

}
} else {
this.$vux.toast.text('接口调用失败')

}
})
},
SubmitBtn: function () {
let param = new URLSearchParams()
param.append('name', this.name)
param.append('mobile', this.mobile)
param.append('school', this.school)
param.append('education', this.education)
param.append('graduate', this.graduate)
param.append('major', this.major)
param.append('stuReason', this.stuReason)
param.append('specificReason',this.specificReason)
param.append('pay', this.picture2)
axios.post('http://student.hmifo.com/admin/application/updateFile', param).then((r) => {
console.log(r)
sessionStorage.setItem('mobile', r.data.mobile)
sessionStorage.setItem('termId', r.data.termId)
if (r.data.code === 401) {
this.$vux.toast.text('您的申请已提交，请勿重复操作！')

}
if (r.data.code === 200) {
this.$router.push({path: '/OnCheck'})
this.$vux.toast.text('编辑成功!')
}
}).catch((error) => {
console.log(error)
this.$vux.toast.text('编辑失败！')
})
},

handleFileChange2(e) {
let inputDOM = this.$refs.inputer2;
this.file = inputDOM.files[0];
let size = Math.floor(this.file.size / 1024);
this.formData2 = new FormData();
this.formData2.append("file", this.file); 

axios.post('http://student.hmifo.com/admin/application/storage/upload', this.formData2).then((r) => {
console.log(r);
if (r.data.code === 200) {

this.picture2 = r.data.data.pictureName
console.log(this.picture2)
this.$vux.toast.text('图片上传成功！')
} else {
this.showDialogStyle = true;
this.picture = true
this.$vux.toast.text('图片上传失败，请重试！')
}
}).catch((error) => {
console.log(error);
this.$vux.toast.text('提交失败!')
})
},
}
}




// WEBPACK FOOTER //
// ./src/components/EditPage.vue